module.exports = __webpack_public_path__ + "img/ruwei.cead0143.png";